const IFRAME_RESIZER_SRC = 'https://brame-static.s3.amazonaws.com/resizer/iframeResizer.min.js';

class ContentBrameWidget extends HTMLElement {
    
    connectedCallback() {
        this.loadIframeResizer();
    }

    loadIframeResizer() {
        if (this.isIframeResizerLoaded()) {
            this.resizeIFrames()
            return;
        }
        const script = document.createElement('script');
        script.src = IFRAME_RESIZER_SRC;
        script.type = 'text/javascript';
        script.async = 0;
        script.onload = () => {
            this.resizeIFrames();
        };
        script.onerror = () => {
            console.error('Fehler beim Laden des iframeResizer-Skripts.');
        };
        document.head.appendChild(script);
    }

    isIframeResizerLoaded() {
        return document.querySelector('script[src="' + IFRAME_RESIZER_SRC + '"]');
    }

    resizeIFrames() {
        // Stelle sicher, dass das iframeResizer-Skript geladen ist
        if (typeof iFrameResize === 'function') {
            const iframes = document.querySelectorAll('iframe.game-iframe');
            iframes.forEach(iframe => {
                iFrameResize({ heightCalculationMethod: 'lowestElement', log: false }, iframe);
            });
        } else {
            console.error('iFrameResize ist nicht verfügbar. Stelle sicher, dass das Skript korrekt geladen wurde.');
        }
    }
}

if (!customElements.get('content-brame-widget')) {
    customElements.define('content-brame-widget', ContentBrameWidget);
}
